<template>
<v-container fluid class="pa-0 ma-0">
<v-alert class="ma-5" border="right" colored-border type="error" elevation="2">
    Vos droits sont insuffisants pour consulter cette section.
    Contactez un administrateur de l'application pour les modifier.
</v-alert>
</v-container>
</template>

<script>
export default {
    name: '401-component'
}
</script>